module.exports = __webpack_public_path__ + "static/media/edit.23e53a5b.svg";